// Name particles kept lower case when not the first word ("Jos van der Berg").
const PARTICLES = new Set(['van', 'von', 'der', 'den', 'de', 'del', 'della', 'di', 'da', 'du', 'la', 'le', 'ten', 'ter', 'y']);

const capitalize = (part: string) => part.charAt(0).toUpperCase() + part.slice(1);

/**
 * Display form of a person's name (rider, owner, breeder).
 *
 * The data layer stores rider names in lower case and sometimes appends a
 * show tag or age ("tiiu saarniit (h*)", "conor o'regan (15)"); both are fixed
 * here. Words that already contain a capital ("McLain", "BV") are left as-is,
 * so correctly cased names and company owners pass through untouched.
 */
export const formatPersonName = (name?: string | null): string | null => {
  if (!name) return null;
  const cleaned = name
    .replace(/\s*\([^)]*\)\s*$/, '')
    .replace(/\s+,/g, ',')
    .trim();
  if (!cleaned) return null;
  return cleaned
    .split(/\s+/)
    .map((word, idx) => {
      if (word !== word.toLowerCase()) return word;
      if (idx > 0 && PARTICLES.has(word)) return word;
      // Capitalize each piece of hyphenated / apostrophe names: "o'regan", "anne-sophie"
      return word.split(/(['’-])/).map(capitalize).join('');
    })
    .join(' ');
};
